/** Destacadas = colección de historias (oct-2026). Guarda IDs de historias, nunca copias del archivo. */
import { api } from './api';

export const storyToPublic = (s) => ({
  id: s.id,
  kind: s.kind || s.mediaType || s.media_type || 'image',
  url: s.url || s.mediaUrl || s.media_url,
  thumbnail_url: s.thumbnail_url ?? s.thumbnailUrl ?? null,
  duration_seconds: s.duration_seconds ?? s.durationSeconds ?? 5,
  created_at: s.created_at || s.createdAt || null,
  expired: Boolean(s.expired),
  highlight_ids: s.highlight_ids || [],
});

export const highlightsApi = {
  list: (barberRef) => api.get(`/highlights/${encodeURIComponent(barberRef)}`),
  create: ({ title, coverUrl, storyIds }) => api.post('/highlights', { title, cover_url: coverUrl || null, story_ids: storyIds }),
  update: (id, { title, coverUrl, storyIds }) => api.put(`/highlights/${id}`, {
    ...(title !== undefined ? { title } : {}),
    ...(coverUrl !== undefined ? { cover_url: coverUrl } : {}),
    ...(storyIds !== undefined ? { story_ids: storyIds } : {}),
  }),
  addStories: (id, storyIds) => api.post(`/highlights/${id}/stories`, { story_ids: storyIds }),
  removeStory: (id, storyId) => api.delete(`/highlights/${id}/stories/${encodeURIComponent(storyId)}`),
  reorder: (ids) => api.put('/highlights/reorder', { ids }),
  remove: (id) => api.delete(`/highlights/${id}`),
  myStories: (scope = 'all') => api.get(`/stories/mine?scope=${scope}`).then((r) => ({ ...r, items: (r.items || []).map(storyToPublic) })),
};

export default highlightsApi;
